import { useState, useEffect } from "react"

const useInteractive = ({ cb } = {}) => {
  const [hasInteracted, setHasInteracted] = useState(false)
  useEffect(() => {
    if (hasInteracted) return () => {}

    const onInterative = () => {
      setHasInteracted(true)

      if (cb) {
        cb()
      }
    }

    document.addEventListener("scroll", onInterative)
    document.addEventListener("mousemove", onInterative)
    document.addEventListener("touchstart", onInterative)
    document.addEventListener("keypress", onInterative)

    return () => {
      // clearTimeout(initGTMAfterDelay)
      document.removeEventListener("scroll", onInterative)
      document.removeEventListener("mousemove", onInterative)
      document.removeEventListener("touchstart", onInterative)
      document.removeEventListener("keypress", onInterative)
    }
  }, [hasInteracted])

  return { hasInteracted }
}

export default useInteractive
